export default {"src":"/_next/static/image/public/images/ic_tick_blue.2ce4eb22771ccd5e94b890628df9ebc2.svg","height":13,"width":18};